import React from 'react'
import '../../App.css';
import './Herosection.css';
import Lottie from 'react-lottie-player';
import lottie from '../Assets/Images/lotties/data.json';
import lottie2 from '../Assets/Images/lotties/data-mobile-2.json';

function Herosection() {

  return (
    <>
      <div className='hero-container' id="Home" >
        <Lottie
          loop
          animationData={lottie}
          play
        />
      </div>
      <div className='hero-container-2' id="Home" >
        <Lottie
          className="lottie"
          loop
          animationData={lottie2}
          play
        />
      </div>
    </>
  );
}

export default Herosection
